export class UpdateTableContextRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "versionId",
            "baseName": "versionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "summary",
            "baseName": "summary",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<TableContextColumnEdit>",
            "format": ""
        },
        {
            "name": "kindNotes",
            "baseName": "kindNotes",
            "type": "Array<TableContextKindEdit>",
            "format": ""
        },
        {
            "name": "notes",
            "baseName": "notes",
            "type": "Array<TableContextNoteEdit>",
            "format": ""
        },
        {
            "name": "newNotes",
            "baseName": "newNotes",
            "type": "Array<TableContextNewNote>",
            "format": ""
        },
        {
            "name": "deletedNotes",
            "baseName": "deletedNotes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "metrics",
            "baseName": "metrics",
            "type": "Array<TableContextMetricEdit>",
            "format": ""
        },
        {
            "name": "deletedMetrics",
            "baseName": "deletedMetrics",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "groupBy",
            "baseName": "groupBy",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "segmentBy",
            "baseName": "segmentBy",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "release",
            "baseName": "release",
            "type": "TableContextRelease",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateTableContextRequest.attributeTypeMap;
    }
    constructor() {
    }
}
